import { Controller } from "@hotwired/stimulus";

/**
 * Recharge un formulaire avec ses valeurs en cours quand un champ maître
 * change (ex. la classe d'un créneau : ses cours, plages et salles changent).
 *
 * <form data-controller="form-refresh" data-form-refresh-url-value="/…/new">
 *   <div data-action="change->form-refresh#refresh">…select de la classe…</div>
 *
 * Visite GET l'URL avec les champs du formulaire (sans jeton ni _method), en
 * remplaçant l'entrée d'historique.
 */
export default class extends Controller {
  static values = { url: String };

  refresh() {
    const data = new FormData(this.element);
    const query = new URLSearchParams();
    for (const [key, value] of data.entries()) {
      if (key === "authenticity_token" || key === "_method") continue;
      if (typeof value === "string") query.append(key, value);
    }
    const url = `${this.urlValue}${this.urlValue.includes("?") ? "&" : "?"}${query}`;
    if (window.Turbo) {
      window.Turbo.visit(url, { action: "replace" });
    } else {
      window.location.replace(url);
    }
  }
}
